const SERVER_URL = window.location.origin === 'https://tos.thirky.com'
  ? 'https://api-tos.thirky.com'
  : 'http://localhost:3030';

export default SERVER_URL;
